import { render } from "./MobileProductsDetailView.vue?vue&type=template&id=cf1effda&scoped=true"
import script from "./MobileProductsDetailView.vue?vue&type=script&lang=js"
export * from "./MobileProductsDetailView.vue?vue&type=script&lang=js"

import "./MobileProductsDetailView.vue?vue&type=style&index=0&id=cf1effda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf1effda"]])

export default __exports__